import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { BlackBadgeStyled } from '../BaseBadge/styled';

const JanuarySaleBadge = () => {
  const { t } = useTranslation();
  return <BlackBadgeStyled>{t('vacation.offer.january_sale_offer')}</BlackBadgeStyled>;
};

export default JanuarySaleBadge;
